import React from 'react';
import { AlertTriangle, CheckCircle2, Info, OctagonAlert } from 'lucide-react';

const ICON = { error: [OctagonAlert, 'text-red-600'], warning: [AlertTriangle, 'text-amber-600'], info: [Info, 'text-gray-500'] };

// Cross-document consistency and completeness findings for the set.
export function ReadinessPanel({ validation }) {
  const errors = validation.filter(function (v) { return v.severity === 'error'; }).length;
  const warnings = validation.filter(function (v) { return v.severity === 'warning'; }).length;
  return (
    <div className="bg-white rounded-sm border border-gray-100 p-5" data-testid="cargo-readiness">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-medium text-ink text-[15px]">Set readiness</h3>
        <span className={'text-[11px] font-medium uppercase tracking-[0.04em] px-2 py-0.5 rounded-full ' + (errors ? 'bg-red-50 text-red-700' : warnings ? 'bg-amber-50 text-amber-800' : 'bg-success-100 text-success-700')} data-testid="cargo-readiness-badge">
          {errors ? errors + ' blocking' : warnings ? warnings + ' to review' : 'Consistent'}
        </span>
      </div>
      {validation.length === 0 ? (
        <p className="text-sm text-gray-600 flex items-center gap-2" data-testid="cargo-readiness-ok"><CheckCircle2 className="h-4 w-4 text-success-500" /> All checks pass — names, weights, references and dates agree across the set.</p>
      ) : (
        <ul className="space-y-2">
          {validation.map(function (v) {
            const [I, cls] = ICON[v.severity] || ICON.info;
            return <li key={v.code} className="flex gap-2 text-[13px] text-gray-700" data-testid={'cargo-issue-' + v.code}><I className={'h-4 w-4 mt-0.5 shrink-0 ' + cls} strokeWidth={1.75} /><span>{v.message}</span></li>;
          })}
        </ul>
      )}
    </div>
  );
}
